import React from "react";
import styles from "./ReconciliationTrend.module.css";

const data = [88, 90, 91, 93, 94, 95, 96, 98, 100];
const labels = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep"];
const yTicks = [80, 85, 90, 95, 100];

const LineChart = ({ values = data, width = 640, height = 220 }) => {
  const padding = { top: 20, right: 16, bottom: 32, left: 56 };
  const chartWidth = width - padding.left - padding.right;
  const chartHeight = height - padding.top - padding.bottom;
  const min = 80;
  const max = 100;

  const x = (i) => padding.left + (i / (values.length - 1)) * chartWidth;
  const y = (value) => padding.top + ((max - value) / (max - min)) * chartHeight;

  const path = values
    .map((value, index) => `${index === 0 ? "M" : "L"} ${x(index)} ${y(value)}`)
    .join(" ");

  return (
    <svg
      className={styles.svg}
      viewBox={`0 0 ${width} ${height}`}
      preserveAspectRatio="xMidYMid meet"
      role="img"
      aria-label="Reconciliation trend line chart"
    >
      <g>
        {/* <text x={padding.left - 12} y={padding.top + 10} className={styles.axisTitle} textAnchor="end">
          Rate
        </text> */}
        {/* <text x={padding.left - 12} y={padding.top + 24} className={styles.axisTitle} textAnchor="end">
          (%)
        </text> */}

        {yTicks.map((tick) => {
          const yPos = y(tick);
          return (
            <g key={tick}>
              <line
                x1={padding.left}
                x2={width - padding.right}
                y1={yPos}
                y2={yPos}
                className={styles.gridLine}
              />
              <text
                x={padding.left - 10}
                y={yPos + 4}
                className={styles.axisLabel}
                textAnchor="end"
              >
                {tick}%
              </text>
            </g>
          );
        })}

        <path d={path} className={styles.dataLine} />

        {values.map((value, index) => (
          <circle
            key={`${value}-${index}`}
            cx={x(index)}
            cy={y(value)}
            r={4.2}
            className={styles.dataPoint}
          />
        ))}

        {labels.map((label, index) => (
          <text
            key={label}
            x={x(index)}
            y={height - 8}
            className={styles.axisLabel}
            textAnchor="middle"
          >
            {label}
          </text>
        ))}
      </g>
    </svg>
  );
};

const ReconciliationTrend = () => {
  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <h3 className={styles.title}>Reconciliation Trend</h3>
        {/* <button type="button" className={styles.timeRange}>
          This Year <span className={styles.chevron}>▾</span>
        </button> */}
      </div>

      <div className={styles.chartWrap}>
        <LineChart />
      </div>
    </div>
  );
};

export default ReconciliationTrend;
